import { render, staticRenderFns } from "./YieldSettingsSpaceUtilization.vue?vue&type=template&id=21ab306c"
import script from "./YieldSettingsSpaceUtilization.vue?vue&type=script&lang=js"
export * from "./YieldSettingsSpaceUtilization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports